module.exports = __webpack_public_path__ + "img/contactless_mobile@2x.3e6679b6.png";